import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import {
  VisibilityOff as VisibilityOffIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import LoadingSpinner from "components/LoadingSpinner";
import useResetPasswordForm from "./useResetPasswordForm";

// import Alert from "../Alert";
// import LoadingSpinner from "../../../components/LoadingSpinner";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"COPYRIGHT © "} {new Date().getFullYear()}
      {" EVOKE MEDICAL CARE - ALL RIGHTS RESERVED"}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    background: theme.palette.secondary.main,
    "&:hover": {
      background: theme.palette.secondary.dark,
    },
  },
}));

const ResetPasswordForm = ({
  loading,
  onSubmitReset,
  alertMessage,
  passwordChanged,
}) => {
  const classes = useStyles();
  const {
    passwordTouched,
    confirmPasswordTouched,
    passwordLengthValid,
    passwordValid,
    confirmPasswordValid,

    passwordVisible,
    password,
    confirmPassword,
    confirmPasswordVisible,

    onSubmit,
    handlePasswordChange,
    handleConfirmPasswordChange,
    togglePasswordVisible,
    toggleConfirmPasswordVisible,
  } = useResetPasswordForm();

  return (
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      {!passwordChanged && (
        <div className={classes.paper}>
          {loading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div style={{ textAlign: "center" }}>
                <LoadingSpinner />
              </div>
              <Typography component="h1" variant="h5">
                Resetting Password
              </Typography>
            </div>
          )}
          {!loading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {/*<Avatar className={classes.avatar}>*/}
              {/*  <LockOutlinedIcon/>*/}
              {/*</Avatar>*/}
              <Typography component="h1" variant="h5">
                Reset Your Password
              </Typography>
            </div>
          )}
          <form
            onSubmit={onSubmit}
            className={classes.form}
            style={{ maxWidth: "480px" }}
            noValidate
          >
            <div style={{ position: "relative" }}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="newPassword"
                label="New Password"
                type={passwordVisible ? "text" : "password"}
                id="password"
                error={
                  (!passwordLengthValid || !passwordValid) && passwordTouched
                }
                autoComplete="current-password"
                onChange={handlePasswordChange}
                value={password}
              />
              {(!passwordLengthValid || !passwordValid) && passwordTouched && (
                <div style={{ color: "red", textAlign: "right" }}>
                  Error: Password must contain at least 12 characters including
                  one number and one special character.
                </div>
              )}
              {!passwordVisible && (
                <VisibilityIcon
                  onClick={togglePasswordVisible}
                  style={{
                    position: "absolute",
                    top: 33,
                    right: 17,
                    zIndex: "999",
                    cursor: "pointer",
                  }}
                />
              )}
              {passwordVisible && (
                <VisibilityOffIcon
                  onClick={togglePasswordVisible}
                  style={{
                    position: "absolute",
                    top: 33,
                    right: 17,
                    zIndex: "999",
                    cursor: "pointer",
                  }}
                />
              )}
            </div>
            <div style={{ position: "relative" }}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm New Password"
                type={confirmPasswordVisible ? "text" : "password"}
                id="confirm_password"
                error={!confirmPasswordValid && confirmPasswordTouched}
                onChange={handleConfirmPasswordChange}
                value={confirmPassword}
              />
              {!confirmPasswordValid && confirmPasswordTouched && (
                <div style={{ color: "red", textAlign: "right" }}>
                  Error: Passwords must match
                </div>
              )}
              {!confirmPasswordVisible && (
                <VisibilityIcon
                  onClick={toggleConfirmPasswordVisible}
                  style={{
                    position: "absolute",
                    top: 33,
                    right: 17,
                    zIndex: "999",
                    cursor: "pointer",
                  }}
                />
              )}
              {confirmPasswordVisible && (
                <VisibilityOffIcon
                  onClick={toggleConfirmPasswordVisible}
                  style={{
                    position: "absolute",
                    top: 33,
                    right: 17,
                    zIndex: "999",
                    cursor: "pointer",
                  }}
                />
              )}
            </div>
            {/* alertMessage && (
              <div style={{ color: "red", textAlign: "center" }}>
                <Alert message={alertMessage} />
              </div>
            ) */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={
                !confirmPasswordValid || !passwordValid || !passwordLengthValid
              }
            >
              Reset Password
            </Button>
          </form>
        </div>
      )}
      {passwordChanged && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            marginTop: 200,
          }}
        >
          <Typography component="h1" variant="h5">
            Password Reset. Redirecting to Login Page...
          </Typography>
        </div>
      )}
      <Box mt={4}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default ResetPasswordForm;
